import Caption from 'LuxKit/Typography/Caption'
import { useIntl } from 'react-intl'

function FlightsCalendarPriceInfo() {
  const intl = useIntl()

  return <Caption variant="smallalt" colour="light-foreground-alt">
    {intl.formatMessage({
      id: 'MeAUltVLiiAcd7CwsWte',
      defaultMessage: 'Based on recent return prices (per adult) found',
      description: 'Information text about pricing basis for flight date selection',
    })}
  </Caption>
}

export default FlightsCalendarPriceInfo
